import React, { useEffect, useState } from "react";
import { Card, Table, Tag, Tabs } from "antd";
// import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPatientAppointmentHistory } from "../../Redux/Slice/Patient/Appointments";

const { TabPane } = Tabs;

const MyAppointments = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user"));
  const patientId = user?.patientId;

  // Get tab from navigation state (default = "today")
  const defaultTab = location.state?.tab || "today";
  const [activeKey, setActiveKey] = useState(defaultTab);

  useEffect(() => {
    
    if (location.state?.tab) {
      setActiveKey(location.state.tab);
    }
  }, [location.state]);

  const { history } = useSelector((state) => state.patientAppointment);

  const todayAppointments = history.today.data || [];
  const upcomingAppointments = history.future.data || [];
  const pastAppointments = history.past.data || [];

  useEffect(() => {
    dispatch(fetchPatientAppointmentHistory({ patientId, filters: "today" }));
    dispatch(fetchPatientAppointmentHistory({ patientId, filters: "past" }));
    dispatch(fetchPatientAppointmentHistory({ patientId, filters: "future" }));
  }, [dispatch, patientId]);

  // Table columns
  const columns = [
    { title: "Doctor", dataIndex: ["doctor", "doctorName"], key: "doctorName" },
    { title: "Speciality", dataIndex: "speciality", key: "speciality" },
    { title: "Branch", dataIndex: ["branch", "branchName"], key: "branchName" },
    {
      title: "Date",
      dataIndex: "appointmentDate",
      key: "appointmentDate",
      // render: (date) => dayjs(date).format("DD MMM YYYY"),
    },
    { title: "Time", dataIndex: "appointmentTime", key: "appointmentTime" },
    {
      title: "Status",
      dataIndex: "confirmStatus",
      key: "confirmStatus",
      render: (status) => {
        let color = "default";
        let label = status;

        switch (status) {
          case "Confirmed":
            color = "green";
            break;
          case "Pending":
          case "UnConfirmed":
            label = "Pending";
            color = "orange";
            break;
          case "Rejected":
            color = "red";
            break;
          case "Cancelled":
            color = "volcano";
            break;
          default:
            color = "blue";
        }

        return <Tag color={color}>{label}</Tag>;
      },
    },
  ];

  return (
    <Card style={{ borderRadius: 12, marginTop: 20 }} title="My Appointments">
      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        <TabPane tab={`Today (${todayAppointments.length})`} key="today">
          <Table
            dataSource={todayAppointments}
            columns={columns}
            rowKey="appointmentId"
            pagination={{ pageSize: 5 }}
            loading={history.today.loading}
          />
        </TabPane>

        <TabPane tab={`Upcoming (${upcomingAppointments.length})`} key="future">
          <Table
            dataSource={upcomingAppointments}
            columns={columns}
            rowKey="appointmentId"
            loading={history.future.loading}
          />
        </TabPane>

        <TabPane tab={`History (${pastAppointments.length})`} key="past">
          <Table
            dataSource={pastAppointments}
            columns={columns}
            rowKey="appointmentId"
            loading={history.past.loading}
          />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default MyAppointments;
